import { ReactNode } from "react";
import Footer from "./Footer";

interface LayoutProps {
  children: ReactNode;
  includeFooter?: boolean;
}

const Layout = ({ children, includeFooter = true }: LayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-grow">
        {children}
      </div>
      {includeFooter && <Footer />}
    </div>
  );
};

export default Layout; 